// @flow
import { RESORT_BARS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_BARS } from 'Utils/request/requestDictionary';

type CMSProps = {
  resortId: string,
  priceInclude: string,
  withSupplement: string,
};

type GQLProps = {
  bars: {
    introduction: {
      included: string,
      withSupplement: string,
    },
    barsList: Array<{
      name: string,
      description: string,
      images: Array<string>,
    }>,
  },
  config: CMSContent,
  resort: Resort,
};

export const productBarsResolver = {
  name: RESORT_BARS,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { resortId: productId } = props;
    const { urlParams } = location;
    const productArgs = buildProductArgs(productId, urlParams);

    const query = `query {
      resort(${productArgs}) {
        adultOnly
      },
      bars(${productArgs}) {
        introduction { included withSupplement }
        barsList { name images description }
      }
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_BARS,
      strictErrors: false,
    });
  },
};
